import { Input } from "antd-v5";
import message from "components/CustomMessage";
import useDebounceCallback from "hooks/useDebounceCallback";
import { flatMap, isFunction, map, omit } from "lodash";
import React, { useCallback, useMemo, useRef, useState } from "react";
import AssetsAPI from "restAPI/AssetAPI";
import { AssetEsDto } from "types/assetdetails";

import SearchIcon from "ac-components/ac-icons/SearchIcon";
import ACSettingSectionCard from "ac-components/ac-setting-section-card/ACSettingSectionCard";
import ACSettingSectionTitle from "ac-components/ac-setting-section-title/ACSettingSectionTitle";
import ACTagTable from "ac-components/ac-tag-table/ACTagTable";

import { RESERVED_TAG_KEYS } from "../../../Findings/Constants";

interface AssetTagTableSectionProps {
  assetDetails: AssetEsDto;
  readOnly?: boolean;
}

const AssetTagTableSection = ({
  assetDetails,
  readOnly = false,
}: AssetTagTableSectionProps) => {
  const tagsMetaMap = {
    ...assetDetails.tagsMetaMap,
  };
  const staticTags = useMemo(() => {
    const tagsMetaMap = assetDetails.tagsMetaMap;
    return tagsMetaMap
      ? flatMap(omit(tagsMetaMap, "MANUAL"), (value) => value)
      : [];
  }, [assetDetails]);

  const [searchTerm, setSearchTerm] = useState("");
  const onSearch = useDebounceCallback(
    (e: React.ChangeEvent<HTMLInputElement>) => setSearchTerm(e.target.value),
    [],
  );
  const assetsTagSuccessMsgRef = useRef({});
  const onTagsChange = useCallback(
    async (tags) => {
      const params = {
        tags: map(
          tags,
          (tag) => `${tag.key}${tag.value ? `:${tag.value}` : ""}`,
        ),
      };
      if (isFunction(assetsTagSuccessMsgRef.current)) {
        assetsTagSuccessMsgRef.current();
      }
      await AssetsAPI.updateTags(assetDetails.id, params).promise;
      assetsTagSuccessMsgRef.current = message.success(
        "Asset tags updated successfully.",
      );
    },
    [assetDetails],
  );

  return (
    <div>
      <ACSettingSectionTitle
        title={
          <div className="d-flex justify-content-between align-items-center">
            <span>Tags</span>
            <Input
              prefix={<SearchIcon />}
              placeholder="Search tags"
              onChange={onSearch}
              allowClear
              style={{ width: 162 }}
            />
          </div>
        }
      />
      <ACSettingSectionCard contentPadding={false}>
        {/* @ts-ignore */}
        <ACTagTable
          source={assetDetails.tags}
          staticTags={staticTags}
          tagsMetaMap={tagsMetaMap}
          editable={!readOnly}
          onChange={onTagsChange}
          preventKeys={RESERVED_TAG_KEYS}
          permission="UPDATE_ASSETS"
          disableAccessText="Only Manual tags are editable"
          prefKey="ac-asset-tag-table"
          searchTerm={searchTerm}
        />
      </ACSettingSectionCard>
    </div>
  );
};
export default AssetTagTableSection;
